import { ThemeProvider, createTheme } from '@mui/material/styles';
import React, { ReactNode } from 'react';

import { ICommonProperties } from '../../common/properties/ICommonProperties';
import { Colors } from '../../view/design/color/Colors';

export interface IApplicationThemeProperties extends ICommonProperties {
  children: ReactNode;
  isFlip?: boolean;
}

export default function ApplicationTheme({ isFlip = false, children }: IApplicationThemeProperties) {
  const theme = createProjectTheme(isFlip);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

const createProjectTheme = (isFlip: boolean) => {
  const theme = createTheme({
    palette: {
      mode: 'dark',
      background: {
        paper: Colors.mainPassive,
        default: Colors.mainPassive,
      },
      primary: { main: Colors.mainActive },
      secondary: { main: Colors.mainActive },
      error: { main: Colors.negativePassive },
    },
    typography: {
      fontFamily: ['Late', 'Roboto', 'Arial', 'sans-serif'].join(','),
      button: { textTransform: 'none' },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          '*': {
            scrollbarColor: '#939393 #2c2c2c',
          },
          '*::-webkit-scrollbar': {
            width: '14px',
            height: '14px',
          },
          '*::-webkit-scrollbar-track': {
            background: '#2c2c2c',
          },
          '*::-webkit-scrollbar-thumb': {
            backgroundColor: '#939393',
            borderRadius: '8px',
          },
          '*::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#b0b0b0',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            width: 'fit-content !important',
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            '&:last-child': {
              paddingRight: '20px',
            },
          },
          paddingNone: {
            '&:last-child': {
              paddingRight: '20px',
            },
          },
        },
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            '.MuiDialogTitle-root + &': {
              paddingTop: '10px',
            },
          },
        },
      },
    },
  });

  return theme;
};
